import defaultProfile from "../../../assets-super-admin/userImg.png";

const ApprovalCard = ({ item, onSelect, onApprove, onReject }) => {
  return (
    <div className="bg-white border border-border rounded-xl p-4 shadow-sm hover:shadow-md transition cursor-pointer">
      {/* Top Section */}
      <div className="flex gap-3">
        <img
          src={item.profileImage || defaultProfile}
          alt="profile"
          className="w-14 h-14 rounded-full object-cover border"
        />

        <div>
          <p className="font-semibold text-text-primary">{item.fullName}</p>
          <p className="text-sm text-text-secondary">{item.email}</p>
          <p className="text-sm text-text-muted">{item.city}</p>
        </div>
      </div>

      {/* Footer Section */}
      <div className="mt-4 flex justify-between items-center">
        <button
          onClick={onSelect}
          className="text-primary font-medium text-sm hover:underline"
        >
          View Details
        </button>

        <div className="flex gap-2">
          <button
            onClick={() => onReject(item)}
            className="px-3 py-1.5 bg-status-danger text-white rounded-lg text-sm hover:bg-red-600"
          >
            Reject
          </button>
          <button
            onClick={() => onApprove(item)}
            className="px-3 py-1.5 bg-status-success text-white rounded-lg text-sm hover:bg-green-600"
          >
            Approve
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalCard;

// import { IoLocationOutline } from "react-icons/io5";

// const ApprovalCard = ({ item, onSelect, onApprove, onReject }) => {
//   return (
//     <div className="bg-background-card rounded-xl border border-border shadow-sm hover:shadow-md transition-all p-5">
//       {/* Header */}
//       <div className="flex  justify-between items-start">
//         <div className="flex flex-col gap-y-1 justify-between items-start">
//           <h3 className="text-text-primary font-semibold text-lg">
//             {item.fullName}
//           </h3>
//           <p className="text-text-muted text-sm ">{item.email}</p>
//           <p className="text-text-secondary text-sm flex gap-1 items-center ">
//             <IoLocationOutline />
//             {item.city || "Unknown"}
//           </p>
//         </div>

//         <span className="px-3 py-1 text-xs rounded-md bg-primary/10 text-primary font-medium">
//           {item.typeLabel}
//         </span>
//       </div>

//       {/* Created Date */}
//       <div className="mt-3 text-xs text-text-muted">
//         Requested On:{" "}
//         <span className="text-text-primary font-medium">
//           {item.createdAtFormatted}
//         </span>
//       </div>

//       {/* Actions */}
//       <div className="flex justify-between items-center mt-5">
//         <button
//           onClick={onSelect}
//           className="px-4 py-2 rounded-lg text-sm bg-primary text-white hover:bg-primary/90 transition"
//         >
//           View Details
//         </button>

//         <div className="flex gap-2">
//           <button
//             onClick={onReject}
//             className="px-4 py-2 rounded-lg text-sm bg-status-danger text-white hover:bg-status-danger/90 transition"
//           >
//             Reject
//           </button>
//           <button
//             onClick={onApprove}
//             className="px-4 py-2 rounded-lg text-sm bg-status-success text-white hover:bg-status-success/90 transition"
//           >
//             Approve
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ApprovalCard;

// // import React from "react";

// // const ApprovalCard = ({ item, onApprove, onReject, onSelect }) => {
// //   return (
// //     <div
// //       className="border rounded-lg p-4 bg-white shadow-sm hover:shadow transition cursor-pointer"
// //       onClick={() => onSelect(item)}
// //     >
// //       {/* Header */}
// //       <div className="flex justify-between items-start">
// //         <h3 className="font-semibold text-text-primary text-base">
// //           {item.title || item.fullName || "Untitled"}
// //         </h3>
// //         <span className="text-sm text-text-muted">{item.typeLabel}</span>
// //       </div>

// //       {/* Info */}
// //       <p className="text-sm text-text-secondary mt-1">
// //         {item.subtitle || item.email || item.city}
// //       </p>

// //       <p className="text-xs text-text-muted mt-1">
// //         {item.createdAtFormatted || "—"}
// //       </p>

// //       {/* Quick Actions */}
// //       <div className="flex gap-3 mt-4">
// //         <button
// //           onClick={(e) => {
// //             e.stopPropagation();
// //             onApprove(item);
// //           }}
// //           className="px-4 py-1.5 text-xs rounded-md bg-status-success text-white hover:bg-green-600"
// //         >
// //           Approve
// //         </button>

// //         <button
// //           onClick={(e) => {
// //             e.stopPropagation();
// //             onReject(item);
// //           }}
// //           className="px-4 py-1.5 text-xs rounded-md bg-status-danger text-white hover:bg-red-600"
// //         >
// //           Reject
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ApprovalCard;
